import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';


const KEY_ACTION = ActionType.LogInfoRequest;
const ACTIONS    = [
  ActionType.LogInfoRequest,
  ActionType.LogInfoResponse,
  ActionType.LogInfoError,
];

type Payload = string;
type Meta = {
  triggeringActionType: ActionType;
}

/**
 * Dispatch this action to add a new dev plan item action
 */
export const logInfoAction = (message: string, triggeringActionType: ActionType) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.LogInfo,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({
    message:  message,
    category: 'Portal',
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { triggeringActionType }),
  bailout:  state => !!getLoading(state, KEY_ACTION, triggeringActionType),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { triggeringActionType } = action.meta;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, triggeringActionType);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, triggeringActionType);
  }

  return noLoadingNoError(state, KEY_ACTION);
};


export const logInfoReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
